export type AlertType =
  | 'success'
  | 'save_success'
  | 'get_success'
  | 'delete_success'
  | 'error'
  | 'get_error'
  | 'save_error'
  | 'send_error'
  | 'delete_error';
export const SuccessAlertTypes: readonly AlertType[] = ['success', 'save_success', 'get_success', 'delete_success'];
export const ErrorAlertTypes: readonly AlertType[] = ['error', 'get_error', 'save_error', 'send_error', 'delete_error'];
